import React from "react";

interface KeyboardArrowDownProps extends React.SVGProps<SVGSVGElement> {
  size?: string;
  fill?: string;
}

const KeyboardArrowDown: React.FC<KeyboardArrowDownProps> = ({
  size = "24",
  fill = "currentColor",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Dropdown arrow icon"
    {...props}
  >
    <path
      d="M7.41 8.795L12 13.375L16.59 8.795L18 10.205L12 16.205L6 10.205L7.41 8.795Z"
      fill={fill}
    />
  </svg>
);

export default KeyboardArrowDown;
